import { render, staticRenderFns } from "./Sketchpad.vue?vue&type=template&id=0fcc615a&scoped=true"
import script from "./Sketchpad.vue?vue&type=script&lang=js"
export * from "./Sketchpad.vue?vue&type=script&lang=js"
import style0 from "./Sketchpad.vue?vue&type=style&index=0&id=0fcc615a&prod&lang=scss&scoped=true"
import style1 from "./Sketchpad.vue?vue&type=style&index=1&id=0fcc615a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcc615a",
  null
  
)

export default component.exports